import { View } from "react-native";
import { BasicModularNavBarTemplate } from "src/components/ModularNavBar";
import { useGatheringStore } from "src/contexts/GatheringContext";
import useDevice from "src/hooks/useDevice";
import useKeyboardListener from "src/hooks/useKeyboardListener";
import { Pill } from "src/swsh-native";
import DynamicSelectButton from "./DynamicSelectButton";

const MiscPhotoViewsGatheringHomeNavBarContent = ({ title }: { title?: string }) => {
	const { device } = useDevice();
	const setViewMode = useGatheringStore((state) => state.setViewMode);
	useKeyboardListener({
		Escape: () => {
			setViewMode("All");
		},
	});

	return (
		<>
			<BasicModularNavBarTemplate
				items={[
					{
						text: "Exit",
						onPress: () => {
							setViewMode("All");
						},
					},
					DynamicSelectButton,
				]}
			/>
			{!!title && (
				<View
					testID="MiscHeaderTitle"
					pointerEvents="box-none"
					style={{
						position: "absolute",
						top: 0,
						left: 0,
						right: 0,
						bottom: 0,
						justifyContent: "center",
						alignItems: "center",
						marginLeft: "auto",
						marginRight: "auto",
					}}
				>
					<Pill opaque sizeVariant={device === "desktop" ? "lg" : "md"}>
						{title}
					</Pill>
				</View>
			)}
		</>
	);
};

export default MiscPhotoViewsGatheringHomeNavBarContent;
